const getRandomBytes = () => (Math.random() * 46656) | 0;

export const generateUID = (): string =>
  getRandomBytes().toString(36) + getRandomBytes().toString(36);
